// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { list, $delete, createOrUpdate, get } from "./operations.js";
export type {
  AdvancedPlatformMetricsListOptionalParams,
  AdvancedPlatformMetricsDeleteOptionalParams,
  AdvancedPlatformMetricsCreateOrUpdateOptionalParams,
  AdvancedPlatformMetricsGetOptionalParams,
} from "./options.js";
